import { render, staticRenderFns } from "./OrderCustomerMain.vue?vue&type=template&id=0a33b446&scoped=true&"
import script from "./OrderCustomerMain.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a33b446",
  null
  
)

export default component.exports